export default __webpack_public_path__ + "static/media/one.e5313f24.svg";